// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchButton_wrapper__5CmI6","svg":"SearchButton_svg__1Bm1b"};